import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

import TextButton from 'components/common/TextButton'
import theme from 'theme'
import gremlinMascotLogoUrl from 'assets/gremlin-mascot.svg'
import Icon from 'components/Icon'
import Image from 'components/common/Image'
import Text, { styles } from 'components/common/Text'

export const SignedOutFormContainer = props => {
  return (
    <main
      css={{
        display: 'block',
        margin: 'auto',
        maxWidth: theme.space[10],
        paddingTop: theme.space[7],
        paddingBottom: theme.space[7]
      }}
      {...props}
    />
  )
}

export const LowerLink = ({ to, children, className, ...rest }) => {
  return (
    <section
      className={className}
      css={{
        fontSize: theme.fontSizes[2],
        textAlign: 'center',
        marginTop: theme.space[3]
      }}
    >
      <Link css={{ color: theme.colors.steel[1] }} to={to} {...rest}>
        {children}
      </Link>
    </section>
  )
}

LowerLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
}

export const UpperBackText = ({ children, to, onClick }) => {
  const Component = to ? Link : TextButton

  return (
    <div css={{ marginBottom: theme.space[2] }}>
      <Component
        data-test-signin-back
        css={{
          fontSize: theme.fontSizes[2],
          display: 'inline-grid',
          gridAutoFlow: 'column',
          gridAutoColumn: 'auto',
          gap: theme.space[1],
          alignItems: 'center',
          justifyItems: 'start'
        }}
        to={to}
        onClick={onClick}
      >
        <Icon
          css={{
            fontSize: theme.fontSizes[2]
          }}
          icon="chevronBack"
        />
        {children}
      </Component>
    </div>
  )
}

UpperBackText.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func
}

const SignedOutForm = ({ title, children, onSubmit }) => {
  return (
    <Fragment>
      <Helmet title={title} />
      <form
        css={{
          border: theme.border.base,
          textAlign: 'center',
          backgroundColor: 'white',
          borderRadius: theme.borderRadius[1],
          paddingLeft: theme.space[7],
          paddingRight: theme.space[7],
          paddingTop: theme.space[5],
          paddingBottom: theme.space[5]
        }}
        onSubmit={onSubmit}
      >
        <Image
          alt="Gremlin"
          height={theme.space[6]}
          src={gremlinMascotLogoUrl}
        />
        <Text
          as="h1"
          css={{
            ...styles.h2,
            fontWeight: theme.fontWeights[0],
            marginTop: theme.space[2],
            marginBottom: theme.space[4]
          }}
        >
          {title}
        </Text>

        {children}
      </form>
    </Fragment>
  )
}

SignedOutForm.propTypes = {
  theme: PropTypes.object,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default SignedOutForm
